import { CustomElement, resolve } from 'aurelia';
import { AccountService, FeedbackService } from '../../services';
import template from './feedback-widget.html';
import './feedback-widget.css';

// Self-contained feedback entry point: a floating button pinned to the screen edge plus the
// comment popup it opens. Renders nothing until FeedbackService.enabled resolves true (the
// server-controlled runtime flag) AND the visitor is a signed-in (registered) user, since the
// submit endpoint requires authentication. All state and the submit behavior live in
// FeedbackService; the popup reuses the shared modal shell styles (.modal-overlay/.login-*)
// with a few feedback-specific additions.
export class FeedbackWidgetElement {
  readonly feedback: FeedbackService = resolve(FeedbackService);
  readonly account: AccountService = resolve(AccountService);
}

export const FeedbackWidget = CustomElement.define({
  name: 'feedback-widget',
  template
}, FeedbackWidgetElement);
